import {
    ICorporationResponse,
    ILocationResponse,
    NotificationType,
} from '@kcftech/prometheustypescriptapiclient';
import { GroupedSubscriptionsDetailsPage } from 'pages/Settings/NotificationSubscriptions/GroupedSubscriptionsDetailsPage';
import { NotificationSubscriptionsPage } from 'pages/Settings/NotificationSubscriptions/NotificationSubscriptionsPage';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

export type NotificationSubscriptionsRouterProps = Readonly<{
    corporation?: ICorporationResponse;
    location?: ILocationResponse;
}>;

export function NotificationSubscriptionsRouter({
    corporation,
    location,
}: NotificationSubscriptionsRouterProps) {
    const { url } = useRouteMatch();

    return (
        <Switch>
            <Route
                path={`${url}/groupView/indicatorAlerts/groupDetail/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        groupId={match.params.Id}
                        notificationType={NotificationType.Indicator}
                    />
                )}
            />
            <Route
                path={`${url}/groupView/indicatorAlerts/locationDetail/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        locationId={match.params.Id}
                        notificationType={NotificationType.Indicator}
                    />
                )}
            />
            <Route
                path={`${url}/groupView/hardware/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        locationId={match.params.Id}
                        notificationType={NotificationType.Hardware}
                    />
                )}
            />
            <Route
                path={`${url}/groupView/machineHealth/groupDetail/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        groupId={match.params.Id}
                        notificationType={NotificationType.MachineHealth}
                    />
                )}
            />
            <Route
                path={`${url}/groupView/machineHealth/locationDetail/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        locationId={match.params.Id}
                        notificationType={NotificationType.MachineHealth}
                    />
                )}
            />
            <Route
                path={`${url}/groupView/hardwareHealth/:Id`}
                render={({ match }) => (
                    <GroupedSubscriptionsDetailsPage
                        locationId={match.params.Id}
                        notificationType={NotificationType.HardwareHealth}
                    />
                )}
            />

            <Route path={url}>
                <NotificationSubscriptionsPage
                    corporation={corporation}
                    location={location}
                />
            </Route>
        </Switch>
    );
}
